module.exports = __webpack_public_path__ + "images/icons/icon-check-ae1a9e55.svg";